import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ConstrucaoVariaveisService} from '../construcao-variaveis.service';
import {Paginacao} from '../../comum/modelos/paginacao';
import {Evento} from '../../comum/eventos/evento';
import {ComumService} from '../../comum/comum.service';
import {DadoTransacional} from '../../comum/modelos/dado-transacional';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-listar-variaveis',
  templateUrl: './listar-variaveis.component.html',
  styleUrls: ['./listar-variaveis.component.css']
})
export class ListarVariaveisComponent implements OnInit {

  filtroPesquisaNomeDadoTransacional: string;
  dadosTransacionais: DadoTransacional[];
  statusCode: number;
  public paginacao: Paginacao;
  public evento: Evento;

  public loading = false;

  constructor(
    private _construcaoVariaveisService: ConstrucaoVariaveisService,
    private _comumService: ComumService,
    private _cookieService: CookieService,
    private router: Router,
    private _authService: AuthService) {
    this.dadosTransacionais = new Array<DadoTransacional>();
    this.paginacao = new Paginacao();
    this.evento = this._comumService.evento;
    this.loading = false;
    if (this.evento !== undefined) {
      setTimeout(() => {
        this._comumService.cleanEvent();
      }, 2000);
    }
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;
    this._construcaoVariaveisService.obterDadosTransacionaisClienteHttp(parseInt(this._cookieService.get('idCliente')))
      .subscribe((dadosTransacionais) => {
        this.dadosTransacionais = dadosTransacionais;
        this.loading = false;
      });
  }

  removerDadoTransacional(dadoTransacional: DadoTransacional): void {

    const self = this;

    this._construcaoVariaveisService.removerDadoTransacionalHttp(dadoTransacional.idDadoTransacional)
      .subscribe(response => {
        this.loading = false;
        this.statusCode = response.status;
        this._comumService.evento.deletar = true;
        this.router.navigate(['variaveis']);
        setTimeout(() => {
          self.evento.limparEventos();
        }, 3000);
      }, errorCode => {
        this.statusCode = errorCode;
        this.loading = false;
      });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeDadoTransacional = filtro.value;
  }

  limparPesquisaPorFiltro(filtro: any): void {
    filtro.value = '';
    this.pesquisarPorFiltro(filtro);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/construcao-variaveis/listar-variaveis/listar-variaveis.component.ts